import React from "react";
import { Dialog } from "@headlessui/react";
import DialogBackdrop from "components/ModalDialogs/DialogBackdrop";
import { useTranslation } from "react-i18next";

function SiteWideAlertModal({
  title,
  description,
  showCloseIcon,
  dialogState,
  setDialogState,
  showCloseButton,
  dialogOnClose = () => setDialogState(false),
  subTitle,
}) {
  const { t } = useTranslation();
  return (
    <Dialog open={dialogState} onClose={dialogOnClose} className="ui-dialogs">
      <DialogBackdrop />
      {/* Full-screen container to center the panel */}
      <div className="fixed inset-0 flex items-center justify-center p-4">
        <Dialog.Panel
          role="dialog"
          aria-modal="true"
          className="ui-default-dialog ui-default-dialog-vertical-center"
        >
          <Dialog.Title className="font-body text-xl font-bold text-left mb-6">
            {title}
            {subTitle && (
              <p className="text-sm text-theme-text-secondary font-normal mt-2">
                {subTitle}
              </p>
            )}
          </Dialog.Title>
          {showCloseIcon && (
            <button className="ui-default-dialog-close" onClick={dialogOnClose}>
              <svg
                className="ui-icon h-3.5 w-3.5"
                focusable="false"
                aria-hidden="true"
                role="presentation"
              >
                <use href="#ui-icon-close"></use>
              </svg>
            </button>
          )}
          <hr />
          {description && (
            <div className="grid grid-cols-1 mt-6">{description}</div>
          )}
          {showCloseButton && (
            <div className="block text-right mt-6">
              <button
                className="ui-btn-secondary min-w-[140px]"
                aria-label="Close"
                onClick={dialogOnClose}
              >
                {t("AgentCSR-Admin-SiteWideAlertModal-button")}
              </button>
            </div>
          )}
        </Dialog.Panel>
      </div>
    </Dialog>
  );
}

export default SiteWideAlertModal;
